/**
 * Shared UI label constants for common strings used across
 * multiple components. Centralizes these values to ensure
 * consistency and simplify future updates.
 */
export const labels = {
  /** Generic "no results" label for autocomplete/select components */
  noResults: 'No results',
  /** More descriptive "no results" label for search inputs */
  noResultsFound: 'No results found',
  /** Loading state label */
  loading: 'Loading...',
} as const;
